var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_849_36783)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_849_36783)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 12.75,
    width: 30,
    height: 30,
    rx: 6,
    fill: "url(#paint0_linear_849_36783)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9989 22.4798C36.1593 22.4948 36.3083 22.5691 36.4168 22.6882C36.5253 22.8073 36.5854 22.9625 36.5854 23.1236C36.5854 23.2846 36.5253 23.4399 36.4168 23.559C36.3083 23.6781 36.1593 23.7524 35.9989 23.7674C35.9093 23.7758 35.8189 23.7653 35.7335 23.7368C35.6481 23.7083 35.5696 23.6622 35.5031 23.6016C35.4365 23.541 35.3834 23.4672 35.347 23.3849C35.3106 23.3026 35.2918 23.2136 35.2918 23.1236C35.2918 23.0336 35.3106 22.9446 35.347 22.8623C35.3834 22.78 35.4365 22.7061 35.5031 22.6455C35.5696 22.585 35.6481 22.5389 35.7335 22.5104C35.8189 22.4818 35.9093 22.4714 35.9989 22.4798Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0335 33.1403C21.9055 33.1403 21.7805 33.1024 21.6741 33.0313C21.5677 32.9603 21.4848 32.8593 21.4359 32.7411C21.3869 32.623 21.3741 32.493 21.3991 32.3675C21.424 32.2421 21.4856 32.1269 21.5761 32.0365C21.6665 31.946 21.7818 31.8845 21.9073 31.8595C22.0327 31.8346 22.1628 31.8474 22.281 31.8963C22.3992 31.9452 22.5002 32.0281 22.5713 32.1344C22.6423 32.2408 22.6803 32.3658 22.6803 32.4937C22.6803 32.6652 22.6121 32.8296 22.4908 32.9509C22.3695 33.0722 22.205 33.1403 22.0335 33.1403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3374 24.3802C31.6684 23.7567 30.823 23.355 29.9169 23.2302C29.0107 23.1054 28.0882 23.2636 27.2754 23.683C25.5881 24.5883 24.6094 26.8148 24.8288 29.5362C23.8735 29.0732 23.0103 28.4407 22.2809 27.6695C20.3743 25.6397 19.7443 23.2557 20.6723 21.7657C21.6004 20.2757 24.0864 19.5841 25.9705 21.6139C26.5836 18.9207 29.0696 18.2403 30.6276 19.1006C32.0618 19.8821 32.7255 21.9456 32.3374 24.3802Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2407 33.3764C34.874 34.9002 32.1743 36.0753 29.992 36.75C28.6309 35.2713 27.0954 33.2696 26.488 31.4366C25.6106 29.0807 26.0549 25.6397 27.866 24.8076C28.5649 24.4553 29.3698 24.3753 30.1244 24.5831C30.879 24.791 31.5294 25.2717 31.9493 25.9321C32.224 26.3547 32.415 26.8262 32.5117 27.3209C32.6017 27.2253 32.703 27.1409 32.7761 27.0566C34.6153 25.3698 36.9269 26.0277 37.8381 27.4783C38.7492 28.9289 38.1193 31.341 36.2407 33.3764Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0709 19.3649C35.0706 19.3128 35.086 19.2619 35.1151 19.2188C35.1442 19.1757 35.1856 19.1423 35.234 19.1231C35.2821 19.1015 35.3359 19.0958 35.3875 19.1069C35.4392 19.1181 35.4858 19.1454 35.5208 19.1849L35.7739 19.4661C35.799 19.4931 35.8295 19.5145 35.8634 19.5291C35.8973 19.5436 35.9339 19.5509 35.9708 19.5504H36.3476C36.4004 19.5473 36.4529 19.5609 36.4976 19.5892C36.5423 19.6174 36.577 19.659 36.5969 19.708C36.6167 19.757 36.6207 19.811 36.6083 19.8624C36.5959 19.9138 36.5676 19.9601 36.5276 19.9946L36.252 20.2476C36.2241 20.272 36.202 20.3024 36.1874 20.3364C36.1728 20.3705 36.166 20.4074 36.1676 20.4444V20.8211C36.1688 20.8738 36.1539 20.9256 36.1248 20.9695C36.0958 21.0135 36.054 21.0475 36.005 21.0671C35.9561 21.0866 35.9024 21.0908 35.851 21.079C35.7997 21.0672 35.7531 21.04 35.7177 21.001L35.4646 20.7255C35.4402 20.6976 35.4098 20.6756 35.3757 20.661C35.3417 20.6464 35.3047 20.6396 35.2677 20.6412H34.8909C34.838 20.6419 34.7862 20.6267 34.7421 20.5976C34.698 20.5685 34.6636 20.5269 34.6434 20.4781C34.6233 20.4293 34.619 20.3754 34.6311 20.3239C34.6432 20.2725 34.6711 20.2262 34.7109 20.1914L34.9865 19.9384C35.0144 19.914 35.0365 19.8836 35.0511 19.8496C35.0657 19.8155 35.0724 19.7786 35.0709 19.7416C35.0709 19.6516 35.0709 19.5111 35.0709 19.3649Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5532 35.2994C24.5346 35.3484 24.5014 35.3906 24.4582 35.4204C24.4151 35.4502 24.3638 35.4661 24.3113 35.4661C24.2589 35.4661 24.2076 35.4502 24.1644 35.4204C24.1212 35.3906 24.0881 35.3484 24.0695 35.2994L23.9401 34.9451C23.9111 34.8768 23.8566 34.8224 23.7883 34.7933L23.4339 34.664C23.3849 34.6454 23.3427 34.6123 23.3129 34.5691C23.2831 34.5259 23.2671 34.4747 23.2671 34.4222C23.2671 34.3698 23.2831 34.3186 23.3129 34.2754C23.3427 34.2322 23.3849 34.1991 23.4339 34.1805L23.7883 34.0511C23.8232 34.0385 23.8549 34.0184 23.8811 33.9921C23.9074 33.9659 23.9275 33.9342 23.9401 33.8993C23.9739 33.815 24.0189 33.6857 24.0695 33.5507C24.0881 33.5017 24.1212 33.4595 24.1644 33.4297C24.2076 33.3999 24.2589 33.384 24.3113 33.384C24.3638 33.384 24.4151 33.3999 24.4582 33.4297C24.5014 33.4595 24.5346 33.5017 24.5532 33.5507C24.6038 33.6857 24.6544 33.815 24.6826 33.8993C24.6952 33.9342 24.7153 33.9659 24.7416 33.9921C24.7678 34.0184 24.7995 34.0385 24.8344 34.0511L25.1888 34.1805C25.2378 34.1991 25.28 34.2322 25.3098 34.2754C25.3396 34.3186 25.3556 34.3698 25.3556 34.4222C25.3556 34.4747 25.3396 34.5259 25.3098 34.5691C25.28 34.6123 25.2378 34.6454 25.1888 34.664L24.8344 34.7933C24.766 34.8224 24.7116 34.8768 24.6826 34.9451C24.6544 35.0351 24.6038 35.1644 24.5532 35.2994Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_849_36783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 12.75,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "url(#paint1_linear_849_36783)",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 13.75,
    width: 26,
    height: 7,
    rx: 3.5,
    fill: "url(#paint2_linear_849_36783)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_849_36783",
    x: 0,
    y: 0,
    width: 58.5,
    height: 58.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15781
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.315 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_849_36783"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_849_36783",
    result: "effect2_dropShadow_849_36783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_849_36783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_849_36783",
    x: 8.625,
    y: 7.125,
    width: 41.25,
    height: 26.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8125,
    result: "effect1_foregroundBlur_849_36783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_36783",
    x1: 18.8654,
    y1: -2.25,
    x2: 59.141,
    y2: 5.47147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_36783",
    x1: 29.25,
    y1: 12.75,
    x2: 29.25,
    y2: 33.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_36783",
    x1: 29.25,
    y1: 13.75,
    x2: 29.25,
    y2: 23.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_36783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 12.75,
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/gf.863752c80211812d73d968c7a7d7b643.svg";
export { ForwardRef as ReactComponent };